(function ($) {
    // ─────────────── Variables ───────────────
    let loadedWidget = false;
    let expandOneTime = false;
    let hasOpenedOneTime = false;
    let lastOneTimePack = 2;
    let hasOpenedSubsave = false;
    let lastSubsavePack = 1;
    const searchIntervalDelay = 100;
    const hardTimeout = 60000;
    const customDiscountSale = 1;

    // ─────────────── Helpers ───────────────
    function formatPrice(p) {
        p = Number(String(p).replace('$', ''));
        let price = p.toFixed(2);
        return String(price).replace('.00', '');
    }

    // ─────────────── Helper to get the current variant ID ───────────────
  function getCurrentVariantId() {
    const radio = document.querySelector('.single-option-selector__radio:checked');
    if (radio) return radio.value;
    const select = document.getElementById('ProductSelect');
    if (select) return select.value;
    if (ShopifyAnalytics?.meta?.selectedVariantId) return String(ShopifyAnalytics.meta.selectedVariantId);
    return null;
  }

  function updatePromoBlocks() {
    // figure out which variant is selected
    const vid = getCurrentVariantId();
    console.log('[updatePromoBlocks] currentVariantId →', vid);
    document.querySelectorAll('.promo-pdp-disclaimer').forEach(el => {
      if (el.getAttribute('data-variant-id') === vid) {
        el.style.display = 'flex';
      } else {
        el.style.display = 'none';
      }
    });
  }
  

  // ─────────────── Swap the “60-Day…” text on sub/save vs one-time ▷ NEW ───────────────
  function updateGuaranteeText() {
    const val = document.querySelector('input[name="custom-rc-radio"]:checked')?.value;
    console.log('[updateGuaranteeText] radio value →', val);
    const el  = document.getElementById('disclaimer-text');
    if (!el) {
      console.warn('[updateGuaranteeText] ❌ disclaimer-text element not found');
      return;
    }
  
    if (val === 'onetime') {
      el.innerHTML = '60-Day Money-Back Guarantee | Free U.S. Shipping Over $60';
    } else {
      el.innerHTML = '60-Day Money-Back Guarantee | Free U.S. Shipping';
    }
    console.log('[updateGuaranteeText] disclaimer-text updated to →', el.innerHTML);
  }
  

    /*
    function disableButton() {
        const $form = $('.product-single__form');
        const variantId = $form.find('[name="id"]').val();
        const available = $form.find(`.jc-custom-rc-available[data-variant-id="${variantId}"]`).data('available');
        const $btn = $form.find('.btn--add-to-cart');
        if (available) {
            $btn.prop('disabled', true).find('#subscription-btn').text('SOLD OUT');
        } else {
            $btn.prop('disabled', false);
            const val = $form.find('.jc-custom-rc-radio__input:checked').val();
            $btn.find('#subscription-btn').text(val === 'subsave' ? 'Add Subscription to Cart' : 'Add to Cart');
        }
    }
    */
    function disableButton() {
        const $form    = $('.product-single__form');
        const variantId= $form.find('[name="id"]').val();
        const available= $form.find(`.jc-custom-rc-available[data-variant-id="${variantId}"]`).data('available');
        const val      = $form.find('.jc-custom-rc-radio__input:checked').val();
        const $btn     = $form.find('.btn--add-to-cart');
        const $planSelect = $('.rc_widget__option__plans__dropdown');
      
        // — button text & disabled state —
        if (available) {
          $btn.prop('disabled', true)
              .find('#subscription-btn').text('SOLD OUT');
        } else {
          $btn.prop('disabled', false)
              .find('#subscription-btn')
              .text(val === 'subsave' ? 'Add Subscription to Cart' : 'Add to Cart');
        }
      
        // — selling_plan <select> must only have a name when subscribing —
        if (val === 'subsave') {
          $planSelect
            .attr('name', 'selling_plan')
            .prop('disabled', false);
        } else {
          $planSelect
            .prop('disabled', true)
            .removeAttr('name');
        }
      }
      

    function changePack() {
        const pack = $('.jc-custom-rc-radio__input:checked')
            .next()
            .find('.jc-custom-rc-radio__pack-item.active')
            .data('pack');
        console.log(`Selected pack: ${pack}`);
        $('.jc-js-quantity-selector').val(pack);
        disableButton();
    }

    function changePlan() {
        const plan = $('.jc-custom-rc-radio__plan-item.active').data('plan');
        console.log(`Selected plan: ${plan}`);
        $(`.rc_widget__option__plans__dropdown>option:eq(${plan})`).prop('selected', true);
        disableButton();
    }

    function updateSubscriptionPrices() {
        const $active = $('.jc-custom-subsave .jc-custom-rc-radio__pack-item.active');
        if (!$active.length) return;
        const cmp = $active.find('.jc-custom-rc__compare-price').text().trim();
        const sale = $active.find('.jc-custom-rc__sale-price').text().trim();
        $('.jc-custom-subsave .jc-custom-rc__price-box .jc-custom-rc__compare-price').text(`$${formatPrice(cmp)}`);
        $('.jc-custom-subsave .jc-custom-rc__sale-price').first().text(`$${formatPrice(sale)}`);
    }

    /*
    function updateOneTimePrices() {
        let $pack = $('.jc-custom-onetime.widget .jc-custom-rc-radio__pack-item.active');
        if (!$pack.length) {
            const $fallback = $('.jc-custom-onetime.widget .jc-custom-rc-radio__pack-item[data-pack="1"]');
            $pack = (!$loadedWidget || !expandOneTime) ? $fallback : $pack;
        }
        if ($pack.length) {
            const cmp = $pack.find('.jc-custom-rc__compare-price').text().trim();
            const sale = $pack.find('.jc-custom-rc__sale-price').text().trim();
            const discountText = $pack.find('.jc-custom-rc__save-price').text().trim() || 'No Discount';
            const $priceBox = $('.jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price');
            if (cmp == 0) {
                $priceBox.html(`<span class="compare-price"></span> <span class="sale-price">$${formatPrice(sale)}</span>`);
            } else {
                $priceBox.html(`<span class="compare-price">$${formatPrice(cmp)}</span> <span class="sale-price">$${formatPrice(sale)}</span>`);
            }
            $('.jc-custom-onetime .jc-custom-rc__save-price.main')
                .text(discountText)
                .toggleClass('no-discount', discountText === 'No Discount');
        } else {
            $('.jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price').empty();
            $('.jc-custom-onetime .jc-custom-rc__save-price.main')
                .text('No Discount')
                .addClass('no-discount');
        }
    }
    */
    function updateOneTimePrices() {
        // find the active pack (or fallback to pack 1)
        let $pack = $('.jc-custom-onetime.widget .jc-custom-rc-radio__pack-item.active');
        if (!$pack.length) {
            const $fallback = $('.jc-custom-onetime.widget .jc-custom-rc-radio__pack-item[data-pack="1"]');
            $pack = (!$loadedWidget || !expandOneTime) ? $fallback : $pack;
        }

        const rawCmp  = $pack.find('.jc-custom-rc__compare-price').text().trim();
        const rawSale = $pack.find('.jc-custom-rc__sale-price').text().trim();
        const cmpNum  = Number(String(rawCmp).replace('$', '')) || 0;
        const saleNum = Number(String(rawSale).replace('$', '')) || 0;
        const discountText = $pack.find('.jc-custom-rc__save-price').text().trim() || 'No Discount';

        const $priceBox = $('.jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price');

        // Only show a compare-at price when it differs from the sale price
        if (cmpNum > 0 && cmpNum > saleNum) {
            $priceBox.html(
                `<span class="compare-price">$${formatPrice(cmpNum)}</span> <span class="sale-price">$${formatPrice(saleNum)}</span>`
            );
        } else {
            $priceBox.html(
                `<span class="sale-price">$${formatPrice(saleNum)}</span>`
            );
        }

        // Ensure pack tiles are NEVER red on PDP
        $(".jc-custom-rc-radio__packs .jc-custom-rc__sale-price")
          .removeClass("red")
          .addClass("standard");

        // update the “you save” text under price
        $('.jc-custom-onetime .jc-custom-rc__save-price.main')
          .text(discountText)
          .toggleClass('no-discount', discountText === 'No Discount');
    }
    

    function updatePackPrices(activePack) {
        if (!activePack) return;
        if ($('.jc-custom-rc-radio__input:checked').val() === 'subsave') {
            updateSubscriptionPrices();
        } else {
            updateOneTimePrices();
        }
    }

    function changeVariant() {
        const price = Number($('[data-price-onetime]').text().trim().replace('$', ''));
        console.log(price);
        const variantId = $('[name="id"]').val();
        document.dispatchEvent(new CustomEvent('variantChanged', {
            detail: { id: String(variantId) }
        }));
        const customDiscount = 1 - Number($(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`).data('discount')) / 100;

        // Update compare prices
        $('.jc-custom-rc__compare-price').text(`$${formatPrice(price)}`);
        [2, 3].forEach(n => {
            $(`[data-pack="${n}"] .jc-custom-rc__compare-price`).text(`$${formatPrice(price * n)}`);
        });

        if (customDiscount) {
            $('.jc-custom-rc-container').removeClass('no-discount-container');
            // One‑time sale price
            if (loadedWidget && expandOneTime) {
                const active = $('.jc-custom-onetime .jc-custom-rc-radio__pack-item.active').data('pack');
                $('.jc-custom-onetime .jc-custom-rc__sale-price').html(
                    `<span class="compare-price">$${formatPrice(price * active)}</span> <span class="sale-price">$${formatPrice(price * active * customDiscount)}</span>`
                );
            } else {
                $('.jc-custom-onetime .jc-custom-rc__sale-price').html(
                    `<span class="compare-price">$${formatPrice(price)}</span> <span class="sale-price">$${formatPrice(price * customDiscount)}</span>`
                );
            }
            // Pack-specific sale prices
            [1, 2, 3].forEach(n => {
                $('.jc-custom-onetime').find(`[data-pack="${n}"] .jc-custom-rc__sale-price`)
                    .text(`$${formatPrice(price * n * customDiscount)}`);
                $('.jc-custom-subsave').find(`[data-pack="${n}"] .jc-custom-rc__sale-price`)
                    .text(`$${formatPrice(price * n * 0.8 * customDiscountSale)}`);
            });
        } else {
            $('.jc-custom-rc-container').addClass('no-discount-container');
            $('.jc-custom-onetime .jc-custom-rc__sale-price').text(`$${formatPrice(price)}`);
            [1, 2, 3].forEach((n, i) => {
                const factor = n === 1 ? 1 : (n === 2 ? 0.9 : 0.85);
                $(`.jc-custom-onetime [data-pack="${n}"] .jc-custom-rc__sale-price`)
                    .text(`$${formatPrice(price * n * factor)}`);
                $('.jc-custom-subsave').find(`[data-pack="${n}"] .jc-custom-rc__sale-price`)
                    .text(`$${formatPrice(price * n * 0.8 * customDiscountSale)}`);
            });

            // No variant-level discount → hide compare-at for 1-pack to avoid showing same price struck out
            $(`.jc-custom-onetime [data-pack="1"] .jc-custom-rc__compare-price`).text('');
        }

           $('.jc-custom-onetime .jc-custom-rc-radio__pack-item, .jc-custom-subsave .jc-custom-rc-radio__pack-item')
             .removeClass('active')
             .filter('[data-pack="1"]').addClass('active');
           lastOneTimePack = lastSubsavePack = 1;
           hasOpenedOneTime = hasOpenedSubsave = false;
        
           // ─── REDRAW BOTH DISCOUNT PILLS ───
           updateOneTimePrices();
           updateSubscriptionPrices();
        
           // Ensure pack tiles are NEVER red on PDP
           $(".jc-custom-rc-radio__packs .jc-custom-rc__sale-price")
             .removeClass("red")
             .addClass("standard");

           // ─── SYNC QUANTITY & BUTTON ───
           changePack();
           disableButton();

        
          // ← Add these two lines:
          updatePromoBlocks();
          updateGuaranteeText();
    }

    /*
    function updatePromoDisclaimer() {
        const val = $('input[name="custom-rc-radio"]:checked').val();

        // existing subscribe‑only disclaimer
        $('.promo-pdp-disclaimer')[val === 'subsave' ? 'hide' : 'hide']();

        // hide the "always‑on" promo‐disclaimer when one‑time is selected
        $('.promo-disclaimer.promo-pdp-disclaimer')[val === 'subsave' ? 'hide' : 'hide']();

        $('.promo-static')[val === 'subsave' ? 'hide' : 'hide']();
    }
    */
   
    function updatePromoDisclaimer() {
      // 1) figure out which variant is selected
      var select = document.getElementById('ProductSelect');
      var vid = select
        ? select.value
        : (ShopifyAnalytics?.meta?.selectedVariantId || '');
  
      // 2) hide all disclaimers
      document.querySelectorAll('.promo-pdp-disclaimer').forEach(el => {
        el.classList.add('hidden');
      });
  
      // 3) show the one matching the selected variant (if any)
      var match = document.querySelector('.promo-pdp-disclaimer[data-variant-id="' + vid + '"]');
      if (match) match.classList.remove('hidden');
    }
  
    // run on page load
    window.addEventListener('load', function() {
      updatePromoDisclaimer();
    });
  
    // run on every variant change
    var variantSelect = document.getElementById('ProductSelect');
    if (variantSelect) {
      variantSelect.addEventListener('change', updatePromoDisclaimer);
    }
    if (window.jQuery) {
      jQuery(document).on('change', '.single-option-selector__radio variantChanged variant:changed', updatePromoDisclaimer);
    }



    function updatePrices() {
        document.querySelectorAll('.jc-custom-rc__compare-price').forEach(el => {
            el.textContent = `$${formatPrice(el.textContent.trim())}`;
        });
        document.querySelectorAll('.jc-custom-rc__sale-price').forEach(el => {
            const cmp = el.querySelector('.compare-price');
            if (cmp) {
                cmp.textContent = `$${formatPrice(cmp.textContent.trim())}`;
                el.querySelector('.sale-price').textContent = `$${formatPrice(el.querySelector('.sale-price').textContent.trim())}`;
            } else {
                el.textContent = `$${formatPrice(el.textContent.trim())}`;
            }
        });
    }

    let searchInterval;
    function searchElement() {
        if (!$('[data-widget-container-wrapper]').length) return;
        updatePrices();
        setTimeout(() => {
            if (!window.location.search.includes('?variant=')) {
                if ($('.single-option-selector__radio[value="2500mg"]').length) {
                    $('.single-option-selector__radio[value="2500mg"]').next().click();
                } else {
                    $('.jc-input-index-2[name="potency"]').next().click();
                }
            } else if ($('.jc-product-page-content-wrapper').data('productId') === "8476876275910") {
                const vid = new URLSearchParams(window.location.search).get("variant");
                $('[data-variant-id]').each((i, el) => {
                    if (el.dataset.variantId === vid) {
                        const wrappers = document.querySelectorAll('fieldset[name="potency"] > .jc-product-page-input-wrapper');
                        const variantEl = wrappers[i];
                        const nextVariant = getNextElement(variantEl);
                        nextVariant.querySelector('input[type="radio"]').click();
                        variantEl.querySelector('.jc-product-page-input-label.potency').click();
                    }
                });
            }
            $('.jc-custom-rc-loading').hide();
            $('.jc-custom-rc-container').fadeIn(200);
            loadedWidget = true;
            disableButton();
            clearInterval(searchInterval);
        }, searchIntervalDelay);
    }

    function stopSearch() {
        clearInterval(searchInterval);
    }

    function showDiscountBadgeIfAny() {
        document.querySelectorAll('.discount-tab.pdp').forEach(el => el.remove());
        const el = document.getElementById('currentVariantDiscount');
        const val = parseInt(el?.getAttribute('data-variant-discount') || '0', 10);
        if (val > 0) {
            const pane = document.querySelector('.tabs-content-product .w-tab-pane.w--tab-active');
            if (!pane) return;
            const badge = document.createElement('div');
            badge.className = 'discount-tab pdp';
            badge.innerHTML = `<span class="discount-text">save</span><span class="discount-text bigger">${val}%</span>`;
            pane.appendChild(badge);
        }
    }

    function getNextElement(el) {
        const list = Array.from(document.querySelectorAll('fieldset[name="potency"] > .jc-product-page-input-wrapper'));
        const idx = list.indexOf(el);
        return list[(idx + 1) % list.length];
    }
    function getSelectedVariantId(){
        // 1) Shopify analytics override (if you need it)
        if (ShopifyAnalytics?.meta?.selectedVariantId) {
          return String(ShopifyAnalytics.meta.selectedVariantId);
        }
        // 2) *Always* use the checked potency (or size) radio first
        const radio = document.querySelector('.single-option-selector__radio:checked');
        if (radio?.value) {
          return String(radio.value);
        }
        // 3) Then your hidden mapping input (if you’re using one)
        const hidden = document.querySelector('form[action="/cart/add"] input[name="id"]');
        if (hidden?.value) {
          return String(hidden.value);
        }
        // 4) Fallback to the <select> (no‑JS fallback)
        const select = document.getElementById('ProductSelect');
        if (select?.value) {
          return String(select.value);
        }
        // 5) Last‑ditch: URL param
        const urlVar = new URLSearchParams(window.location.search).get('variant');
        if (urlVar) {
          return String(urlVar);
        }
        return '';
      }
      

    // ─────────────── Variant Thumbnails ───────────────
    function updateVariantThumbnails() {
        const vid = getSelectedVariantId();
        if (!vid) return console.log('❓ no variant selected');
        const jsonEl = document.getElementById('ProductJson-{{ section.id }}');
        if (!jsonEl) return console.error('Missing ProductJson');
        const pd = JSON.parse(jsonEl.textContent);
        const variant = pd.variants.find(v => String(v.id) === vid);
        const src = variant?.featured_image?.src || pd.featured_image?.src;
        if (!src) return console.warn('No featured image');
        const normalize = u => u.replace(/^https?:/, '');
        const featured = normalize(src);
        const container = document.querySelector('.tabs-wrapper-product .tabs-product');
        if (!container) return console.error('Cannot find .tabs-product');
        const panes = Array.from(container.querySelectorAll('.w-tab-pane')).map(pane => ({
            id: pane.dataset.imageId,
            pane,
            src: normalize(pane.querySelector('img')?.src || '')
        }));
        let start = panes.findIndex(d => d.src === featured);
        if (start < 0) return console.error('Featured not in panes');
        const thumbs = Array.from({ length: 5 }, (_, i) => panes[(start + i) % panes.length]);
        const menu = container.querySelector('.tabs-menu-product');
        menu.innerHTML = thumbs.map((t, i) => `
        <a href="#" data-image-id="${t.id}" class="tab-menu-link-product w-inline-block w-tab-link${i ? '' : ' w--current'}" style="background-image:url(${t.src});"></a>
      `).join('');
        menu.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                menu.querySelectorAll('a').forEach(a => a.classList.toggle('w--current', a === link));
                panes.forEach(d => {
                    const show = d.id === link.dataset.imageId;
                    d.pane.style.display = show ? '' : 'none';
                    d.pane.setAttribute('aria-hidden', show ? 'false' : 'true');
                });
            });
        });
        menu.querySelector('a')?.click();
    }

    // ─────────────── Hidden Input Mapping ───────────────
    function initVariantMapping() {
        const mapping = {
            "44502852436166": "37546503733446",
            "44502852468934": "42726923010246",
            "44502852501702": "43162448625862"
        };
        const form = document.querySelector('form[action="/cart/add"]');
        const select = document.getElementById('ProductSelect');
        if (!form || !select) return;
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'id';
        form.appendChild(hiddenInput);

        function updateHidden() {
            const val = select.value;
            hiddenInput.value = mapping[val] || val;
        }
        select.addEventListener('change', updateHidden);
        let last = select.value;
        setInterval(() => {
            if (select.value !== last) {
                last = select.value;
                updateHidden();
            }
        }, 300);
        document.addEventListener('variant:changed', updateHidden);
        form.addEventListener('submit', () => select.removeAttribute('name'));
        updateHidden();
    }

    
    // ─────────────── Pack Selection Event ───────────────
    function initPackSelection() {
        const items = document.querySelectorAll('.jc-custom-rc-radio__pack-item');
        if (!items.length) return;
        items.forEach(i => {
            i.addEventListener('click', () => {
                items.forEach(j => j.classList.remove('active'));
                i.classList.add('active');
                const pack = i.dataset.pack;
                window.selectedPack = pack;
                document.dispatchEvent(new CustomEvent('pack:changed', { detail: { pack } }));
            });
        });
        // Initialize
        const active = document.querySelector('.jc-custom-rc-radio__pack-item.active');
        if (active) {
            document.dispatchEvent(new CustomEvent('pack:changed', { detail: { pack: active.dataset.pack } }));
        }
    }

    // ─────────────── Potency Popup ───────────────
    function initPotencyPopup() {
        const buttons = document.querySelectorAll('.potency-btn');
        const popup = document.getElementById('potencyPopup');
        buttons.forEach(btn => btn.addEventListener('click', e => {
            e.preventDefault();
            popup.style.display = 'flex';
        }));
        popup.addEventListener('click', e => {
            if (e.target === popup) popup.style.display = 'none';
        });
        const closeBtn = document.querySelector('.close-btn');
        if (closeBtn) closeBtn.addEventListener('click', () => popup.style.display = 'none');
    }

    // ─────────────── Variant Label Update ───────────────
    function initVariantLabel() {
        function updateLabel() {
            const id = ShopifyAnalytics.meta.selectedVariantId;
            let note = window.variantPriceNotes[id];
            if (note) note = $('<textarea/>').html(note).text();
            if (note) {
                $('.jc-custom-subsave .jc-custom-rc__label-heading').text("Subscribe & Save ~35%");
            }
        }
        $(document).on('change', '.single-option-selector__radio', updateLabel);
    }

    // ─────────────── Initialization ───────────────
    $(document).ready(() => {
      console.log('[INIT] document ready — running initial updaters');
        const $radios = $('.single-option-selector__radio');
        const $select = $('#ProductSelect');


        const hasMultipleVariants =
          $radios.length > 1 ||
          ($select.length && $select.find('option').length > 1);
      
        // ───────── Always bind radio-input changes ─────────
        $(document).on('change', '.jc-product-page-form-wrapper .jc-custom-rc-radio__input', function() {
            expandOneTime = true;
            const val = $(this).val();
            const $planSelect = $('.rc_widget__option__plans__dropdown');
          
            if (val === 'subsave') {
              // — Enable the subscription select so Shopify adds a sub —
              $planSelect
                .attr('name', 'selling_plan')
                .prop('disabled', false);
          
              $('#subscription-btn').text('Add Subscription to Cart');
              $('#disclaimer-text').html(
                $(window).width() < 768
                  ? '60-Day Money-Back Guarantee<br>Free U.S. Shipping'
                  : '60-Day Money-Back Guarantee | Free U.S. Shipping'
              );
          
              // restore last subscribe-pack
              const $subPacks = $('.jc-custom-subsave .jc-custom-rc-radio__pack-item');
              $subPacks.removeClass('active');
              if (!hasOpenedSubsave) {
                hasOpenedSubsave = true;
                lastSubsavePack = 1;
              }
              $subPacks.filter(`[data-pack="${lastSubsavePack}"]`).addClass('active');
              updateSubscriptionPrices();
              updateOneTimePrices();
          
            } else {
              // — Disable/remove the select so Shopify treats it as one-time —
              $planSelect
                .prop('disabled', true)
                .removeAttr('name');
          
              $('#subscription-btn').text('Add to Cart');
              if ($(window).width() < 768) {
                $('#disclaimer-text').html('60-Day Money-Back Guarantee<br>Free U.S. Shipping Over $60');
                $('body, html').scrollTop($('.jc-custom-onetime').position().top + 540);
              } else {
                $('#disclaimer-text').text('60-Day Money-Back Guarantee | Free U.S. Shipping Over $60');
              }
          
              // restore last one-time pack
              const $onePacks = $('.jc-custom-onetime .jc-custom-rc-radio__pack-item');
              $onePacks.removeClass('active');
              if (!hasOpenedOneTime) {
                hasOpenedOneTime = true;
                lastOneTimePack = 2;
              }
              $onePacks.filter(`[data-pack="${lastOneTimePack}"]`).addClass('active');
              updateOneTimePrices();
              updateOneTimePrices();
            }

            updateOneTimePrices();
            updateSubscriptionPrices();
          
            changePack();
            disableButton();
            updatePromoDisclaimer();
          });
          
      
        // ───────── Always bind pack clicks ─────────
        $(document).on('click', '.jc-custom-rc-radio__pack-item', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const $wrapper = $(this).closest('.jc-custom-rc-radio');
          $wrapper.find('.jc-custom-rc-radio__pack-item').removeClass('active');
          $(this).addClass('active');
      
          if ($wrapper.hasClass('jc-custom-onetime')) {
            lastOneTimePack = $(this).data('pack');
            updateOneTimePrices();
          } else {
            hasOpenedSubsave = true;
            lastSubsavePack = $(this).data('pack');
            updateSubscriptionPrices();
          }
      
          changePack();
          disableButton();
        });
      
        // ───────── Single-variant early exit ─────────
        if (!hasMultipleVariants) {
          updateOneTimePrices();
          updateSubscriptionPrices();
          updatePackPrices($('.jc-custom-rc-radio__pack-item.active').data('pack'));
          disableButton();
          showDiscountBadgeIfAny();
          return;
        }
      
        // ───────── Multi-variant initialization ─────────
        updatePromoDisclaimer();
        searchInterval = setInterval(searchElement, searchIntervalDelay);
        setTimeout(stopSearch, hardTimeout);
        showDiscountBadgeIfAny();
        initVariantMapping();
        initPackSelection();
        initPotencyPopup();
        initVariantLabel();

        updatePromoBlocks();
        updateGuaranteeText();

        $('.single-option-selector__radio, #ProductSelect').on('change', () => {
          console.log('[EVENT] variant selector changed');
          console.log('  → getCurrentVariantId =', getCurrentVariantId());
          updateGuaranteeText();
          updatePromoBlocks();
        });

        $(document).on('change', 'input[name="custom-rc-radio"]', () => {
          const val = $('input[name="custom-rc-radio"]:checked').val();
          console.log('[EVENT] subscription-type toggled →', val);
          updateGuaranteeText();
          updatePromoBlocks();
        });
      
        // ───────── Other event bindings ─────────
        $(document).on('change', '.jc-product-page-form-wrapper .single-option-selector__radio', () => {
          setTimeout(changeVariant, 100);
          updatePromoDisclaimer();
        });
        $(document).on('click', '.jc-product-page-form-wrapper .jc-custom-ra-radio-wrapper', () => {
          updateSubscriptionPrices();
          updateOneTimePrices();
        });
        $(document).on('click', '.jc-product-page-form-wrapper .jc-custom-rc-radio__plan-item', function () {
          $('.jc-custom-rc-radio__plan-item').removeClass('active');
          $(this).addClass('active');
          changePlan();
        });

        document.addEventListener('variantChanged', () => {
          updatePromoBlocks();
          updateGuaranteeText();
        });
      
        // ───────── Thumbnail updater ─────────
        setTimeout(updateVariantThumbnails, 500);
        function onVariantChangeThumbs() { setTimeout(updateVariantThumbnails, 50); }
        $(document).on('change', '[name="id"], .single-option-selector__radio', onVariantChangeThumbs);
        $(document).on('variantChanged variant:changed', onVariantChangeThumbs);
        $(document).on('click', '.tabs-menu-product .tab-menu-link-product', () => {
          setTimeout(updateVariantThumbnails, 50);
        });
      });
      
      
})(jQuery);
